import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MeService } from '../../global-services/me.service';
import { CrudUserComponent } from '../crud-user/crud-user.component'; // Import the crud-user component
import { MeModel } from '../../global-data-models/me.model';
import { Subscription } from 'rxjs';
import { PanelModule } from 'primeng/panel';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { GlobalLangChooserComponent } from '../../global-components/global-lang-chooser/global-lang-chooser.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { GlobalLoadingService } from '../../global-services/global-loading.service';
import { GlobalMessageService } from '../../global-services/global-message.service';
import { getAuth } from 'firebase/auth';

@Component({
  selector: 'app-me',
  imports: [...COMMON_IMPORTS, CrudUserComponent, GlobalLangChooserComponent, TranslateModule, ConfirmDialogModule],
  templateUrl: './me.component.html',
  styleUrls: ['./me.component.css'],
  providers: [ConfirmationService],
})
export class MeComponent implements OnInit {
  me: MeModel | null = null;
  private sub = new Subscription();
  mode: 'read' | 'update' = 'read';

  constructor(
    private meService: MeService,
    private confirmationService: ConfirmationService,
    private loadingService: GlobalLoadingService,
    private messageService: GlobalMessageService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.sub.add(
      this.meService.me$.subscribe((meData) => {
        this.me = meData;
      }),
    );
    if (!this.meService.getLastMeEmitted()) {
      this.meService.refreshMe();
      return;
    }

    this.me = this.meService.getLastMeEmitted();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  enableEditMode() {
    this.mode = 'update';
  }

  onUpdateSuccess() {
    this.mode = 'read'; // Switch back to read mode
    console.log('Profile updated successfully');
  }

  onCancel() {
    this.mode = 'read'; // Switch back to read mode
    console.log('Profile update cancelled');
  }

  deleteUser(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message:
        'Deleting the user may not necessarily delete the organisation and all patient data. If you wish to delete the organisation and all patient data, please contact support, mark.nattriss@wolffsohnresearch.com,  Are you sure you want to proceed?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',
      accept: async () => {
        try {
          await this.meService.deleteMe();
          this.messageService.showSuccess('Account Deleted', 'Your account has been successfully deleted.');
          this.loadingService.show();
          const auth = getAuth();
          await auth.signOut();
          this.router.navigate(['/sign-in']);
        } catch (error) {
          console.error('Error deleting user:', error);
          this.messageService.showError('Error', 'There was an error deleting your account. Please try again later.');
        } finally {
          this.loadingService.hide();
        }
      },
      reject: () => {
        // rejection logic
      },
    });
  }
}
